// 宿替え: shells are what a crab can do. Any crab can wear any shell. Traits
// change how wakes and bodies behave, never raw power.
import { ONE } from './num.js';

const u = v => Math.round(v * ONE);

// rarity: 0 common, 1 uncommon, 2 rare, 3 legendary (drop weights in meta/beach.js)
export const SHELLS = {
  sazae:       { rarity: 0, trait: 'heavy',       glass: '#9fd16a', tags: ['driftwood', 'current'] },
  horagai:     { rarity: 0, trait: 'horn',        glass: '#ff8a5c', tags: ['boss'] },
  takaragai:   { rarity: 0, trait: 'lucky',       glass: '#ffc23a', tags: ['pearls'] },
  tsumetagai:  { rarity: 0, trait: 'longWake',    glass: '#b9a2ff', tags: ['swift', 'rain'] },
  uminina:     { rarity: 1, trait: 'kelpGlide',   glass: '#7fb0a0', tags: ['kelp'] },
  reishi:      { rarity: 1, trait: 'spiny',       glass: '#d9a0c0', tags: ['anemone'] },
  sugai:       { rarity: 1, trait: 'anchor',      glass: '#8aa6d8', tags: ['current'] },
  koshidaka:   { rarity: 1, trait: 'vortexBoost', glass: '#5fd0e0', tags: ['vortex'] },
  bateira:     { rarity: 2, trait: 'wideWake',    glass: '#f0e6a0', tags: ['bloom', 'swift'] },
  takobune:    { rarity: 2, trait: 'paperWake',   glass: '#f4f0e4', tags: ['rain'] },
  oumugai:     { rarity: 3, trait: 'foresight',   glass: '#e8b070', tags: ['fog'] },
};

// Holes cut in each shell's paper puppet in the 影絵 look (presentation only):
// 0 round, 1 slots, 2 spots, 3 spiral, 4 ribs.
export const SHELL_HOLES = { sazae: 0, horagai: 1, takaragai: 2, tsumetagai: 3, uminina: 1, reishi: 0, sugai: 3, koshidaka: 1, bateira: 2, takobune: 4, oumugai: 4 };

// Each crab's own shell, worn in tonight's tide (the same for everyone).
export const DEFAULT_SHELLS = { goro: 'sazae', bou: 'horagai', chika: 'takaragai', mio: 'tsumetagai' };

// Numbers the sim reads for a crab wearing `shell`.
export function traitParams(shell) {
  const t = SHELLS[shell]?.trait;
  return {
    mass: t === 'heavy' ? 4 : t === 'anchor' ? 5 : 3,
    wakeMul: t === 'wideWake' ? 1300 : t === 'paperWake' ? 800 : 1000,   // per mille
    wakeLife: t === 'longWake' ? 1 : t === 'paperWake' ? 2 : 0,           // extra turns a wake keeps blocking
    kelpGlide: t === 'kelpGlide',
    spiny: t === 'spiny',
    anchor: t === 'anchor',
    vortexBoost: t === 'vortexBoost' ? 1400 : 1000,
    horn: t === 'horn',
    pearlReach: t === 'lucky' ? u(0.45) : 0,
  };
}
